<template>
    <div class="home">
        <!-- TODO: find Tucuxi logo -->
        <div class="logo-container">
            <img src="@/assets/images/logo/logo-white-text-vertical.svg" alt="Tucuxi logo">
        </div>

        <nav class="home-menu">
            <a class="menu-tile" href="#" @click="onCreateNewPatient">
                <img src="@/assets/pictos/home-menu-entries/new-patient.svg" alt="" />
                <span>New Patient</span>
            </a>

            <a class="menu-tile disabled" href="#" @click="onLoadInterpretation">
                <img src="@/assets/pictos/home-menu-entries/load-interpretation.svg" alt="" />
                <span>Load interpretation</span>
            </a>

            <a class="menu-tile disabled" href="#" @click="onShowPendingRequests">
                <img src="@/assets/pictos/home-menu-entries/pending-requests.svg" alt="" />
                <span>Pending requests</span>
            </a>
        </nav>

        <div class="copyright">
            <span>Copyright (c) HEIG-VD/CHUV - {{ copyrightYear }}</span>
        </div>
    </div>
</template>

<script lang="ts">
import { usePatientStore } from '@/store/patient';
import { useRequestDataStore } from '@/store/request-data';
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({

    setup()
    {
        const router = useRouter();
        const copyrightYear = (new Date()).getFullYear();

        function onCreateNewPatient(e : Event)
        {
            e.preventDefault();

            // Clear stores so we start with a fresh patient
            usePatientStore().$reset();
            useRequestDataStore().deselectDrug();

            // Navigate to the app
            router.push("/app");
        }

        function onLoadInterpretation(e : Event)
        {
            e.preventDefault();
        }

        function onShowPendingRequests(e : Event)
        {
            e.preventDefault();
        }

        return {
            copyrightYear,
            onCreateNewPatient,
            onLoadInterpretation,
            onShowPendingRequests,
        };
    },
})
</script>

<style lang="scss" scoped>

.home {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    padding: 3rem;
    background-image: url('../assets/images/home-background.png');
    background-repeat: no-repeat;
    background-size: cover;
}

.logo-container > img {
    width: 15.5rem;
}

.copyright {
    font-size: 0.65rem;
    color: $white;
}

.home-menu {
    display: flex;
    margin-top: 5rem;
    margin-bottom: 2rem;

    & > .menu-tile {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 11.5rem;
        margin: 0.55rem;
        padding: 3rem 0.5rem;
        background-color: fade-out($gray-100, 0.25);
        text-align: center;
        color: $gray-600;

        & > img {
            display: block;
            margin-top: 0.25rem;
            margin-left: auto;
            margin-right: auto;
            margin-bottom: 2.65rem;
        }

        &:hover {
            background-color: $white;
            color: darken($gray-600, 60%);
        }

        &:hover > img {
            filter: brightness(20%);
        }

        // Disabled tiles styles
        &.disabled {
            background-color: fade-out($gray-100, 0.60);
            color: darken($gray-600, 0.25);
            cursor: not-allowed;

            & > img {
                filter: brightness(75%);
            }
        }
    }
}

</style>
